<template>
    <div class="section_introduction">
        <div class="grid-x">
            <div class="section_introduction--main cell small-12 large-7">
                <div class="grid-container">
                    <div class="grid-x grid-padding-x align-right">
                        <div class="cell small-12 large-shrink">
                            <section class="section_introduction--articles">
                                <h2 class="section--title"><strong>Introduction</strong></h2>

                                <article class="intro_article">
                                    <h3 class="intro_article--title">同じ顔をした二人の男と、一人の女・・・。人は人の何に惹かれるのか？
                                        <br>心をかき乱し、恋愛観を揺さぶる「大人の恋愛映画」の傑作が誕生！
                                    </h3>
                                    <p class="intro_article--content">東京。サラリーマンの亮平は、会社にコーヒーを届けに来た朝子と出会う。真っ直ぐに想いを伝える亮平に、戸惑いながらも惹かれていく朝子。ふたりは仲を深めていくが、朝子には亮平に告げられない秘密があった。亮平は、かつて朝子が運命的な恋に落ちた恋人・麦に顔がそっくりだったのだ――。
                                        <br>同じ顔をした二人の男と、その間で揺れ動く女の８年間を丁寧に、そしてスリリングに描く本作は問いかける。人はなぜ人を愛するのか？その人の何に惹かれ、なぜその人でなくてはならないのかー？傷つけ、傷つきながらも、誰かを愛さずにはいられない。まっすぐな想いが引き起こす衝撃の展開に、観る者は共感、時に反感さえ覚えるだろう。心をかき乱され、恋愛観を揺さぶられる、ただならぬ「大人の恋愛映画」の傑作が誕生した。</p>
                                </article>

                                <article class="intro_article">
                                    <h3 class="intro_article--title">主演：東出昌大×監督：濱口竜介×原作：柴崎友香×音楽：tofubeats
                                        <br>世界が感嘆！新しい才能によって生み出された「日本映画の新しい波！」
                                    </h3>

                                    <p class="intro_article--content">突如姿を消し、朝子が心のどこかで思い続ける運命の人・麦を、掴みどころのない不思議な佇まいで具現化し、一途に朝子を想う・亮平を、やさしさと包容力で体現したのは東出昌大。初の一人二役で新境地を見せた本作は、東出の新たな「代表作」になるだろう。麦と亮平の間で揺れ動くヒロイン朝子には、”新星”唐田えりか。本作が本格演技デビューの唐田は、スクリーンの中で朝子と共に成長し、その瑞々しさで観客を魅了する。瀬戸康史、山下リオ、伊藤沙莉、渡辺大知、仲本工事、田中美佐子の豪華キャストが脇を固め、物語に深みを与えているのも見逃せない。
                                        <br>監督は、前作『ハッピーアワー』（15）でロカルノ、ナントをはじめ数々の国際映画祭で主要賞を受賞しその名を世界に轟かせた気鋭・濱口竜介。芥川賞作家・柴崎友香による原作「寝ても覚めても」に惚れ込み、その映画化で満を持して商業映画デビューを果たす。また、日本のエレクトロミュージックを若くして牽引するtofubeatsが映画音楽に初挑戦。物語の情感に寄り添う劇伴、本作のために書き下ろした主題歌「River」が、切なくも爽やかな余韻を残す。新しい才能が集結し生まれた本作は、カンヌ国際映画祭コンペティション部門に選出され、「日本映画の新しい波！」と海外メディアが絶賛した。
                                    </p>
                                </article>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'introduction',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue